import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Chip } from '@flatfy/supernova-new';
import { FlatsFiltersContentContext } from '../../FlatsFilters/FlatsFiltersContext';
import FlatsFilters from '../../FlatsFilters/FlatsFilters';
import PlansTrigger from './PlansTrigger';
import CloseIcon from '../../icons/close.svg';
import { attachGaDataAttributes } from '../../helpers/analytics';
import { useFilterReset } from '../../FlatsFilters/FlatsFiltersReset/useFilterReset';
import useMediaQuery from '../../FlatsFilters/useMediaQuery';

const PlansFilter = ({ requestUrl }) => {
  const [filterParams, setFilterParams] = useState({});
  const { searchParams } = useContext(FlatsFiltersContentContext);
  const { handleResetClick, disabled } = useFilterReset(['building_id']);
  const [triggerEl, setTriggerEl] = useState(null);
  const isMobile = useMediaQuery();

  return (
    <>
      {isMobile && (
        <div className="PlansFilter-row">
          {filterParams.ready_state && (
            <FlatsFilters.Select filterParams={{ readyState: filterParams.ready_state }} />
          )}
          <PlansTrigger setTriggerEl={setTriggerEl} />
        </div>
      )}
      <FlatsFilters
        className="PlansFilter"
        requestUrl={requestUrl}
        requestParams={{
          building_id: window.params.buildingId,
          lang: window.currentLanguage,
        }}
        onResponse={(response) => setFilterParams(response.data)}
        skipKeys={['building_id']}
        triggerEl={triggerEl}
      >
        <div className="UIGrid -always-wrap-md -always-wrap-sm -no-mobile-gallery">
          {!isMobile && filterParams.ready_state && (
            <div className="UIGrid-col-6 UIGrid-col-md-12">
              <FlatsFilters.Select filterParams={{ readyState: filterParams.ready_state }} />
            </div>
          )}
          {!!filterParams.abs_min_area && (
            <div className="UIGrid-col-3 UIGrid-col-md-12">
              <FlatsFilters.Range
                type="area"
                event={{
                  category: window.eventCategory,
                  action: 'filters',
                  label: 'area_click',
                }}
                rangeMin={filterParams.abs_min_area}
                rangeMax={filterParams.abs_max_area}
                minValue={
                  searchParams.min_area ? Number(searchParams.min_area) : filterParams.abs_min_area
                }
                maxValue={
                  searchParams.max_area ? Number(searchParams.max_area) : filterParams.abs_max_area
                }
              />
            </div>
          )}
          {!!filterParams.abs_min_floor && (
            <div className="UIGrid-col-3 UIGrid-col-md-12">
              <FlatsFilters.Range
                type="floor"
                event={{
                  category: window.eventCategory,
                  action: 'filters',
                  label: 'floor_click',
                }}
                rangeMin={filterParams.abs_min_floor}
                rangeMax={filterParams.abs_max_floor}
                minValue={
                  searchParams.min_floor
                    ? Number(searchParams.min_floor)
                    : filterParams.abs_min_floor
                }
                maxValue={
                  searchParams.max_floor
                    ? Number(searchParams.max_floor)
                    : filterParams.abs_max_floor
                }
              />
            </div>
          )}
        </div>
        <div className="PlansFilter-chips">
          {filterParams.rooms_count && (
            <FlatsFilters.Section filterParams={filterParams.rooms_count} />
          )}
          {filterParams.features && <FlatsFilters.Section filterParams={filterParams.features} />}
          {filterParams.show_sold && <FlatsFilters.Switch filterParams={filterParams.show_sold} />}
          <Chip
            className="PlansFilter-reset"
            active={!disabled}
            onClick={handleResetClick}
            icon={<CloseIcon />}
            {...attachGaDataAttributes({
              category: window.eventCategory,
              action: 'filters',
              label: 'reset_click',
            })}
          >
            <FormattedMessage id="reset" />
          </Chip>
        </div>
      </FlatsFilters>
    </>
  );
};

PlansFilter.propTypes = {
  opened: PropTypes.bool.isRequired,
  requestUrl: PropTypes.string.isRequired,
};

export default PlansFilter;
